import styled from "styled-components";

export const HeaderWrapper = styled.div`
  min-height: 61px;
  display: block;
`;

export const Header = styled.div`
  height: 100%;
  background: ${props => props.theme.primary};
  padding: 0 17px;
  display: flex;
`;

export const HeaderLeft = styled.div`
  display: flex;
`;

export const HeaderCenter = styled.div`
  width: 100%;
`;

export const HeaderRight = styled.div`
  display: flex;
`;

export const Logo = styled.div`
  display: inline-block;
  padding: 11px 10px;
  cursor: default;

  img {
    width: 27px;
  }
`;

export const Title = styled.div`
  color: #f1f4f5;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: default;
`;



// WEBPACK FOOTER //
// ./src/components/SRHHeaders/ObservationsHeader/style.js